import { mix, rgba } from 'polished';
import styled, { css } from 'styled-components';
import { supportFieldLineLayout } from '@clds/toolbar-layout';
import { typographyMixin } from '@clds/typography';
import { borderVariant, textAreaSizeVariant, textareaTheme } from '../theme.js';
export const FieldBase = styled.div `
  ${(props) => typographyMixin(props.size, 'regular')};
  align-items: center;
  background-color: ${textareaTheme.background.color.base};
  border: ${(props) => textAreaSizeVariant(props).border.width} solid
    ${(props) => borderVariant(props).color};
  border-radius: ${(props) => textAreaSizeVariant(props).border.radius};
  ${supportFieldLineLayout()};
  color: ${textareaTheme.color.base};
  display: flex;
  min-width: 120px;
  transition:
    border-color 250ms,
    box-shadow 250ms;

  ${({ isFocused }) => isFocused &&
    css `
      border-color: ${textareaTheme.border.focus.color};
      box-shadow: 0 0 0 3px
        ${(props) => rgba(textareaTheme.outline.color.base(props), 0.5)};
    `}

  ${({ isDisabled }) => isDisabled
    ? css `
          background-color: ${(props) => mix(0.5, textareaTheme.background.color.base(props), textareaTheme.background.color.contrast(props))};
          border-color: ${(props) => mix(0.5, textareaTheme.border.base.color(props), textareaTheme.border.disabled.color(props))};
          color: ${(props) => mix(0.5, textareaTheme.color.base(props), textareaTheme.color.contrast(props))};
        `
    : css `
          &:hover {
            border-color: ${textareaTheme.border.hover.color};
          }
        `}

  > textarea {
    ${(props) => typographyMixin(props.size, 'regular')};
    background: none;
    resize: ${({ resizeDirection }) => resizeDirection};
    border: none;
    color: ${textareaTheme.color.inputBase};
    height: 100%;
    padding: ${(props) => textAreaSizeVariant(props).padding};
    width: 100%;
    min-height: ${(props) => props.theme.spacing.lg};

    &:disabled,
    &::placeholder {
      color: ${textareaTheme.color.placeholder};
    }

    &:focus {
      outline: none;
    }
    &:disabled,
    &[readOnly] {
      resize: none;
    }
  }
`;
